import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemApiClient } from '../clients/system-api/SystemApiClientp';
import { ChangePasswordForUserRequestData, ChangePasswordRequestData, Int32SecurityResult, LoginRequestData, LoginUserDataSecurityResult, PaginationArgs, SecurityResultStatus, UserProfileDataPaginationDataAdministrationResult, UserRoleDataAdministrationResult } from '../clients/system-api/SystemApiClient';
@Injectable({
  providedIn: 'root'
})
export class UserService {


  constructor(private systemApiClient: SystemApiClient) { }

  retriveUserDetail(userId: number | undefined): Observable<UserRoleDataAdministrationResult> {
    return this.systemApiClient.retrieveUserDetail(userId);
  }
  changePasswordForUser(userId: number | undefined, body: ChangePasswordForUserRequestData  | undefined): Observable<SecurityResultStatus> {
    return this.systemApiClient.changePasswordForUser(userId, body);
  }

  changePassword(body: ChangePasswordRequestData  | undefined): Observable<SecurityResultStatus> {
    return this.systemApiClient.changePassword(body);
  }

  generateResetPasswordCode(email: string | null | undefined): Observable<Int32SecurityResult> {
    return this.systemApiClient.generateResetPasswordCode(email!);
  }

  resetPasswordWithCode(verificationCodeId: number | undefined, resertPasswordCode: string | null | undefined, newPassword: string | null | undefined): Observable<SecurityResultStatus> {
    return this.systemApiClient.resetPasswordWithCode(verificationCodeId, resertPasswordCode!, newPassword!);
  }

  retriveAllUsers(roleId: number | undefined, serviceId: number | undefined = undefined): Observable<UserProfileDataPaginationDataAdministrationResult> {
    return this.systemApiClient.retrieveAllUsers(roleId, undefined, serviceId);
  }

  // resendVerificationCodesForUser(userId: number | undefined): Observable<BackOfficeResultStatus>
  // {
  //   return this.systemApiClient.resendVerificationCodesForUser(userId);
  // }

  login(body: LoginRequestData | undefined): Observable<LoginUserDataSecurityResult> {
    return this.systemApiClient.login(body);
  }

  signout(): Observable<SecurityResultStatus> {
    return this.systemApiClient.signout();
   }

  // retrieveMobileAppUsersPaged(body: PaginationArgs | undefined) : Observable<UserDataPaginationDataBackOfficeResult>{
  //   return this.systemApiClient.retrieveMobileAppUsersPaged(body);
  // }

  // generateMobileAppUsersExcelReport(body: PaginationArgs | undefined): Observable<FileResponse>{
  //   return this.systemApiClient.generateMobileAppUsersExcelReport(body);
  // }
}
